module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(/*! ./transform/filter */ "./src/transform/filter.ts"), exports);
__exportStar(__webpack_require__(/*! ./transform/filterer */ "./src/transform/filterer.ts"), exports);
__exportStar(__webpack_require__(/*! ./transform/map */ "./src/transform/map.ts"), exports);
__exportStar(__webpack_require__(/*! ./transform/mapper */ "./src/transform/mapper.ts"), exports);
__exportStar(__webpack_require__(/*! ./transform/reduce */ "./src/transform/reduce.ts"), exports);
__exportStar(__webpack_require__(/*! ./transform/reducer */ "./src/transform/reducer.ts"), exports);
__exportStar(__webpack_require__(/*! ./types/Filter */ "./src/types/Filter.ts"), exports);
__exportStar(__webpack_require__(/*! ./types/FilterCallback */ "./src/types/FilterCallback.ts"), exports);
__exportStar(__webpack_require__(/*! ./types/Mapper */ "./src/types/Mapper.ts"), exports);
__exportStar(__webpack_require__(/*! ./types/MapperCallback */ "./src/types/MapperCallback.ts"), exports);
__exportStar(__webpack_require__(/*! ./types/Reducer */ "./src/types/Reducer.ts"), exports);
__exportStar(__webpack_require__(/*! ./types/ReducerCallback */ "./src/types/ReducerCallback.ts"), exports);
__exportStar(__webpack_require__(/*! ./utils/getFirstKey */ "./src/utils/getFirstKey.ts"), exports);
__exportStar(__webpack_require__(/*! ./utils/isEmpty */ "./src/utils/isEmpty.ts"), exports);
__exportStar(__webpack_require__(/*! ./utils/pipe */ "./src/utils/pipe.ts"), exports);


/***/ }),

/***/ "./src/transform/filter.ts":
/*!*********************************!*\
  !*** ./src/transform/filter.ts ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.filter = void 0;
function filter(object, callback) {
    var result = {};
    for (var key in object) {
        var value = object[key];
        if (callback(value, key)) {
            result[key] = value;
        }
    }
    return result;
}
exports.filter = filter;


/***/ }),

/***/ "./src/transform/filterer.ts":
/*!***********************************!*\
  !*** ./src/transform/filterer.ts ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.filterer = void 0;
function filterer(callback) {
    return ["filter", callback];
}
exports.filterer = filterer;


/***/ }),

/***/ "./src/transform/map.ts":
/*!******************************!*\
  !*** ./src/transform/map.ts ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.map = void 0;
function map(object, callback) {
    var result = {};
    for (var key in object) {
        result[key] = callback(object[key], key);
    }
    return result;
}
exports.map = map;


/***/ }),

/***/ "./src/transform/mapper.ts":
/*!*********************************!*\
  !*** ./src/transform/mapper.ts ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.mapper = void 0;
function mapper(callback) {
    return ["map", callback];
}
exports.mapper = mapper;


/***/ }),

/***/ "./src/transform/reduce.ts":
/*!*********************************!*\
  !*** ./src/transform/reduce.ts ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.reduce = void 0;
function reduce(object, callback, initial) {
    var result = initial;
    for (var key in object) {
        var value = object[key];
        result = callback(result, value, key);
    }
    return result;
}
exports.reduce = reduce;


/***/ }),

/***/ "./src/transform/reducer.ts":
/*!**********************************!*\
  !*** ./src/transform/reducer.ts ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = void 0;
function reducer(callback, initial) {
    return ["reduce", callback, initial];
}
exports.reducer = reducer;


/***/ }),

/***/ "./src/types/Filter.ts":
/*!*****************************!*\
  !*** ./src/types/Filter.ts ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/types/FilterCallback.ts":
/*!*************************************!*\
  !*** ./src/types/FilterCallback.ts ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/types/Mapper.ts":
/*!*****************************!*\
  !*** ./src/types/Mapper.ts ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/types/MapperCallback.ts":
/*!*************************************!*\
  !*** ./src/types/MapperCallback.ts ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/types/Reducer.ts":
/*!******************************!*\
  !*** ./src/types/Reducer.ts ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/types/ReducerCallback.ts":
/*!**************************************!*\
  !*** ./src/types/ReducerCallback.ts ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/utils/getFirstKey.ts":
/*!**********************************!*\
  !*** ./src/utils/getFirstKey.ts ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirstKey = void 0;
function getFirstKey(object) {
    for (var key in object) {
        return key;
    }
}
exports.getFirstKey = getFirstKey;


/***/ }),

/***/ "./src/utils/isEmpty.ts":
/*!******************************!*\
  !*** ./src/utils/isEmpty.ts ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmpty = void 0;
function isEmpty(object) {
    for (var key in object) {
        return false;
    }
    return true;
}
exports.isEmpty = isEmpty;


/***/ }),

/***/ "./src/utils/pipe.ts":
/*!***************************!*\
  !*** ./src/utils/pipe.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.pipe = void 0;
var filter_1 = __webpack_require__(/*! ../transform/filter */ "./src/transform/filter.ts");
var map_1 = __webpack_require__(/*! ../transform/map */ "./src/transform/map.ts");
var reduce_1 = __webpack_require__(/*! ../transform/reduce */ "./src/transform/reduce.ts");
function pipe(object, transforms) {
    var result = object;
    for (var _i = 0, transforms_1 = transforms; _i < transforms_1.length; _i++) {
        var transform = transforms_1[_i];
        var type = transform[0], callback = transform[1];
        switch (type) {
            case "filter":
                result = filter_1.filter(result, callback);
                break;
            case "map":
                result = map_1.map(result, callback);
                break;
            case "reduce":
                var initial = transform[2];
                result = reduce_1.reduce(result, callback, initial);
                break;
        }
    }
    return result;
}
exports.pipe = pipe;


/***/ })

/******/ });
//# sourceMappingURL=index.js.map